// ─────────────────────────────────────────────────────────────
// Sito pubblico www (Next.js, ollylife.com) — l'app autenticata
// vive su app.ollylife.com; le pagine marketing/SEO stanno su www.
// ─────────────────────────────────────────────────────────────

export const WEB_URL = (import.meta.env.VITE_WEB_URL || 'https://ollylife.com').replace(/\/$/, '')

/** URL assoluto verso il sito pubblico www (home, ricerca, blog, legali). */
export function webUrl(path = '/'): string {
  return `${WEB_URL}${path.startsWith('/') ? path : `/${path}`}`
}
